<template>
  <div>
    <b-modal id="modal-buscar-placa" data-backdrop="static" data-keyboard="false" size="xl" centered>
      <template #modal-header>
        <div class="col-12 row">
          <div class="col-12 col-md-9">
            <h4>Pesquisa de OS por placa</h4>
          </div>
          <div class="col-12 col-md-3">
            <v-select :options="veiculos" :placeholder="$t('Placa')" v-model="placa"
              @input="getPlacaPreventivas(placa)">
            </v-select>
          </div>
        </div>
      </template>

      <div class="container">

        <div class="container mb-2">
          <h5>OS Preventiva Vencida</h5>
          <div v-if="placaPreventiva.nr_seq_os_preventiva == null && placaPreventiva.st_preventiva == 'V'">
            <!-- <p>{{ this.placaPreventiva }}</p> -->
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">{{ $t('PLACA') }}</th>
                  <th scope="col">{{ $t('PROX. CICLO') }}</th>
                  <th scope="col">{{ $t('KM PROX.') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ placaPreventiva.nr_placa }}</td>
                  <td>{{ placaPreventiva.ds_prox_ciclo }}</td>
                  <td>{{ placaPreventiva.km_proximo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr>
        <div class="container mb-2">
          <h5>OS Preventiva A Vencer</h5>
          <div v-if="placaPreventiva.nr_seq_os_preventiva == null && placaPreventiva.st_preventiva == 'A'">
            <!-- <p>{{ this.placaPreventiva }}</p> -->
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">{{ $t('PLACA') }}</th>
                  <th scope="col">{{ $t('PROX. CICLO') }}</th>
                  <th scope="col">{{ $t('KM PROX.') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ placaPreventiva.nr_placa }}</td>
                  <td>{{ placaPreventiva.ds_prox_ciclo }}</td>
                  <td>{{ placaPreventiva.km_proximo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr>
        <div class="container mb-2">
          <h5>OS já está aberta</h5>
          <div v-if="placaPreventiva.nr_seq_os_preventiva != null">
            <!-- <p>{{ this.placaPreventiva }}</p> -->
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">{{ $t('PLACA') }}</th>
                  <th scope="col">{{ $t('PROX. CICLO') }}</th>
                  <th scope="col">{{ $t('KM PROX.') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ placaPreventiva.nr_placa }}</td>
                  <td>{{ placaPreventiva.ds_prox_ciclo }}</td>
                  <td>{{ placaPreventiva.km_proximo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="w-100">
          <div class="row center" style="justify-content: center; ">
            <b-button class="mr-2" variant="danger" size="lg" @click="cancel()">
              {{ $t('Fechar') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>

export default {
  name: 'ModalItems',
  data() {
    return {
      placa: ''
    }
  },
  methods: {
    getPlacaPreventivas(placa) {
      if(placa){
        this.$store.dispatch('veiculo/fetchPlacaPreventiva', { data: placa }).then(response => {
          console.log(response)
          if(response.data[0].cd_prox_ciclo == null){
            this.$swal.fire({
              title: 'Oops!',
              text: 'Todos os itens estão dentro do prazo ou não há planos vinculados no momento.',
              icon: 'success'
            })

            return false
          }
        }) 
      } else {
        placa = ''
      }
    }
  },
  
  computed: {
    placaPreventiva() {
      const placa = this.$store.getters['veiculo/getPlacaPreventiva']

      if(!placa){
        // this.$store.dispatch('veiculo/fetchPlacaPreventiva', { data: this.placa })

        return []
      }

      return placa
    },
    veiculos() {
      const items = this.$store.getters['veiculo/itemsTemp']

      if (!items) {
        this.$store.dispatch('veiculo/fetchFromApi')
        return []
      }

      return items.map(item => {
        return {
          ...item,
          label: item.nr_placa
        }
      })
    },
  },

  mounted() {

  },

}
</script>